const actions = {
    GET_OUTSIDE_EMAIL: 'GET_OUTSIDE_EMAIL',
    GET_OUTSIDE_EMAIL_SUCCESS: 'GET_OUTSIDE_EMAIL_SUCCESS',
    GET_OUTSIDE_EMAIL_FAIL: 'GET_OUTSIDE_EMAIL_FAIL',

    READ_OUTSIDE_EMAIL: 'READ_OUTSIDE_EMAIL',
    READ_OUTSIDE_EMAIL_SUCCESS: 'READ_OUTSIDE_EMAIL_SUCCESS',
    READ_OUTSIDE_EMAIL_FAIL: 'READ_OUTSIDE_EMAIL_FAIL',

    CLOSE_OUTSIDE_EMAIL_TEMPLATE: 'CLOSE_OUTSIDE_EMAIL_TEMPLATE',
    RESET_EMAIL_TEMPLATE_DATA: 'RESET_EMAIL_TEMPLATE_DATA',

    getOutsideEmail: (searchData) => ({
        type: actions.GET_OUTSIDE_EMAIL,
        payload: { searchData }
    }),

    getOutsideEmailSuccess: (data) => ({
        type: actions.GET_OUTSIDE_EMAIL_SUCCESS,
        payload: { data }
    }),
    getOutsideEmailFail: (error) => ({
        type: actions.GET_OUTSIDE_EMAIL_FAIL,
        payload: { error }
    }),

    readOutsideMail: (mailID) => ({
        type: actions.READ_OUTSIDE_EMAIL,
        payload: { mailID }
    }),

    readOutsideMailSuccess: (message, mailID) => ({
        type: actions.READ_OUTSIDE_EMAIL_SUCCESS,
        payload: { message, mailID }
    }),

    readOutsideEMailFail: (error) => ({
        type: actions.READ_OUTSIDE_EMAIL_FAIL,
        payload: { error }
    }),

    closeOutsideEMailTemplate: (mailID) => ({
        type: actions.CLOSE_OUTSIDE_EMAIL_TEMPLATE,
        payload: { mailID }
    }),

    resetEmailTemplateData: () => ({
        type: actions.RESET_EMAIL_TEMPLATE_DATA,
    })
};

export default actions;
